/**
 * Builder extras (Workflows P5-3): undo / redo, path names, the live validation and notes. The backend mirrors are
 * `NOTES_MAX` / `NOTE_TEXT_MAX` in `app/core/constants/workflows.py` and the 80-character `Label` of a path.
 */

/** Undo / redo: how many edits are kept, and the window in which edits of one field (typing) merge into one. */
export const WORKFLOW_HISTORY = { max: 100, coalesceMs: 800 } as const;

/** A path's own name (`Path.label`, 1..80 characters). */
export const WORKFLOW_PATH_LABEL_MAX = 80;

/** How long the live checks wait after the last edit before they run again (ms). */
export const WORKFLOW_PROBLEM_DEBOUNCE_MS = 300;

/** Sticky notes (`definition.notes`): at most `max`, each `textMax` characters. */
export const WORKFLOW_NOTES = { max: 20, textMax: 500 } as const;

/**
 * Steps whose `text` the visitor reads and a translation may replace (backend `graph_p4._TEXT_STEPS`). A step type that
 * gets a translatable text joins both lists.
 */
export const WORKFLOW_TEXT_STEP_TYPES: ReadonlySet<string> = new Set(["send_message", "reply_buttons", "collect_data", "collect_reply", "ask_rating", "show_article", "verify_email"]);
